import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomBaseStore } from '@city/const';
import { CityService } from '@city/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Suggestion } from '@spartacus/core';
import { GeocodeResult } from '@yandex-maps/const';
import { AddressSuggestionsService, GeocodeService } from '@yandex-maps/feature';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';

@Component({
  selector: 'ui-address-suggestions-select',
  templateUrl: './address-suggestions-select.component.html',
  styleUrls: ['./address-suggestions-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AddressSuggestionsService],
  standalone: false,
})
export class AddressSuggestionsSelectComponent implements OnInit, OnDestroy {
  @Input() label?: string;
  @Output() changeAddress = new EventEmitter<GeocodeResult | undefined>();

  control: FormControl = new FormControl();
  iconType = CUSTOM_ICON_TYPE;
  suggestions$: Observable<Suggestion[]> = this.suggestionsService.suggestions$;
  suggestIsLoading$: Observable<boolean> = this.suggestionsService.loading$;
  selectTypeahead = new EventEmitter<string>();

  private subscription = new Subscription();

  constructor(
    private suggestionsService: AddressSuggestionsService,
    private cityService: CityService,
    private geocodeService: GeocodeService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.selectTypeahead.pipe(debounceTime(700)).subscribe(this.suggestionsService.loadSuggestions),
    );

    this.subscription.add(
      combineLatest([
        this.control.valueChanges.pipe(distinctUntilChanged()),
        this.cityService.activeBaseStore$,
      ]).subscribe(([address, city]) => {
        if (this.addressIsOnlyCity(address, city)) {
          this.changeAddress.emit(undefined);
        }

        this.geocodeService
          .getGeoObject(address)
          .pipe(take(1))
          .subscribe((geoObject: GeocodeResult) => {
            this.changeAddress.emit(geoObject);
          });
      }),
    );
  }

  onChangeSelect(suggestion: string): void {
    this.control.setValue(suggestion);
  }

  onBlurSelect(e: FocusEvent): void {
    const input = e.target as HTMLInputElement;
    if (this.control.value !== input.value) {
      this.control.setValue(input.value);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private addressIsOnlyCity(address: string, city: CustomBaseStore): boolean {
    return [`${city.name},`, `Россия, ${city.name}`, `${city.name}, Россия`].includes(address.trim());
  }
}
